__turbopack_context__.v({
  "header-content": "hZweRW_header-content",
  "header-content--secondary": "hZweRW_header-content--secondary",
  "header-content__controls": "hZweRW_header-content__controls",
  "header-content__logo": "hZweRW_header-content__logo",
});
